import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Space, Table, Tag, Button, Select, Spin, Modal, Input, message } from 'antd';
import '../../styles/table-responsive.scss';
const { Option } = Select;

//Order list component
const CustomTable = ({ title, data, onResend, onIgnore, onRefresh, storePaymentGateway }) => {
 
 // 隐藏展开图标的函数
    const expandIcon = () => null;
    const [filterOption, setFilterOption] = useState('failed');
    // const sydneyCurrentDate = moment.tz('Australia/Sydney').format('YYYY-MM-DD');
    // const [selectedDate, setSelectedDate] = useState(sydneyCurrentDate);
    const [tableData, setTableData] = useState([]);
    const [tableScroll, setTableScroll] = useState(undefined);
    
    // 退款相关状态
    const [refundModalVisible, setRefundModalVisible] = useState(false);
    const [confirmRefundModalVisible, setConfirmRefundModalVisible] = useState(false);
    const [refundHistoryModalVisible, setRefundHistoryModalVisible] = useState(false);
    const [refundAmount, setRefundAmount] = useState('');
    const [confirmText, setConfirmText] = useState('');
    const [currentRefundOrder, setCurrentRefundOrder] = useState(null);
    const [refundLoading, setRefundLoading] = useState(false);
    const [refundRequestId, setRefundRequestId] = useState('');
    
    useEffect(() => {
    
      switch (filterOption) {
        case 'failed':
          setTableData(data.filter(item => !item.OrderEnrichNo));
          break;
        case 'success':
          setTableData(data.filter(item => item.OrderEnrichNo));
          break;
        case 'all':
          setTableData(data);
          break;
        default:
          setTableData(data);
      }
    }, [data, filterOption]);
    const handleFilterChange = (value) => {
      setFilterOption(value);
    };
    const [loadingStates, setLoadingStates] = useState({});

  // 处理 Resend 按钮点击事件
  const handleResend = (orderId) => {
    // Older POS clients cannot detect a repeated order, so resending one they
    // already saved prints it twice.
    Modal.confirm({
      title: 'Resend this order to the POS?',
      content: 'Please check the POS first. If this order is already there, resending it may create a duplicate order.',
      okText: 'Resend',
      onOk: () => {
        // 设置对应订单的加载状态为 true
        setLoadingStates(prev => ({ ...prev, [orderId]: true }));

        // 调用传入的 onResend 函数
        onResend(orderId);

        // 设置一个定时器，在一段时间后取消加载状态
        setTimeout(() => {
          setLoadingStates(prev => ({ ...prev, [orderId]: false }));
        }, 4500); // 例如 4 秒后重置状态
      },
    });
  };

  // 处理 Ignore 按钮点击事件
  const handleIgnore = (orderId) => {
    // 设置对应订单的加载状态为 true
    setLoadingStates(prev => ({ ...prev, [`ignore_${orderId}`]: true }));

    // 调用传入的 onIgnore 函数
    onIgnore(orderId);

    // 设置一个定时器，在一段时间后取消加载状态
    setTimeout(() => {
      setLoadingStates(prev => ({ ...prev, [`ignore_${orderId}`]: false }));
    }, 4500); // 例如 4 秒后重置状态
  };

  // 处理退款按钮点击
  const handleRefundClick = (record) => {
    setCurrentRefundOrder(record);
    setRefundAmount('');
    setRefundRequestId(
      window.crypto?.randomUUID?.()
        || `${Date.now()}_${record.OrderId}_${Math.random().toString(36).slice(2)}`
    );
    setRefundModalVisible(true);
  };

  // 处理退款金额确认
  const handleRefundAmountConfirm = () => {
    const amount = parseFloat(refundAmount);
    const paidAmount = parseFloat(currentRefundOrder.Paid);
    
    if (!refundAmount || isNaN(amount)) {
      message.error('Please enter a valid refund amount');
      return;
    }
    
    if (amount <= 0) {
      message.error('Refund amount must be greater than 0');
      return;
    }
    
    if (amount > paidAmount + 0.01) { // 允许0.01的误差
      message.error(`Refund amount cannot exceed paid amount $${formatAmount(paidAmount)}`);
      return;
    }
    
    setRefundModalVisible(false);
    setConfirmText('');
    setConfirmRefundModalVisible(true);
  };

  // 处理最终退款确认
  const handleFinalRefundConfirm = async () => {
    if (confirmText.toLowerCase() !== 'refund') {
      message.error('Please enter "refund" to confirm');
      return;
    }
    
    setRefundLoading(true);
    
    try {
      const token = sessionStorage.getItem('jwtToken');
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/refund-order`, {
        
        
          orderId: currentRefundOrder.OrderId,
          refundAmount: parseFloat(refundAmount),
          refundRequestId,
        },
        config
      );
      
     if (response.status >= 200 && response.status < 300) {
        message.success(response.data.message || 'Refund request submitted successfully');
        setConfirmRefundModalVisible(false);
        setCurrentRefundOrder(null);
        setRefundAmount('');
        setConfirmText('');
        setRefundRequestId('');
        if (onRefresh) {
          onRefresh(); // Call onRefresh after successful refund
        }
      } else {
        message.error(response.data.message || 'Refund failed');
      }
    } catch (error) {
      console.error('Refund error:', error);
      if (error.response && error.response.data) {
        message.error(error.response.data.message || 'Refund request failed, please try again later');
      } else {
        message.error('Refund request failed, please try again later');
      }
    } finally {
      setRefundLoading(false);
    }
  };

  // 处理退款历史显示
  const handleRefundHistoryClick = (record) => {
    setCurrentRefundOrder(record);
    setRefundHistoryModalVisible(true);
  };

  // 计算退款状态
  const getRefundStatus = (record) => {
    const refunds = record.refunds || [];
    if (refunds.length === 0) return null;
    const hasPendingRefund = refunds.some(refund => refund.Status === 'PENDING');
    
    const totalRefunded = refunds.reduce((sum, refund) => {
      return refund.Status === 'SUCCESS' ? sum + parseFloat(refund.RefundAmount) : sum;
    }, 0);
    
    const paidAmount = parseFloat(record.Paid);
    
    if (hasPendingRefund) return 'REFUND_PENDING';
    if (totalRefunded <= 0.01) return null;
    if (paidAmount <= 0.01) return 'FULLY_REFUNDED';
    return 'PARTIALLY_REFUNDED';
  };

  // 格式化金额显示，处理浮点数精度问题
  const formatAmount = (amount) => {
    const num = parseFloat(amount);
    if (isNaN(num)) return '0.00';
    
    // 如果绝对值小于0.01，视为0
    if (Math.abs(num) < 0.01) return '0.00';
    
    return num.toFixed(2);
  };

  const getServiceModeLabel = (serviceMode) => {
    const normalized = String(serviceMode ?? '').trim().toLowerCase();
    if (normalized === '1' || normalized === 'take-away' || normalized === 'takeaway') {
      return 'Takeaway';
    }
    if (normalized === '2' || normalized === 'delivery') {
      return 'Delivery';
    }
    return null;
  };

    useEffect(() => {
      // 检测屏幕宽度
      const checkScreenSize = () => {
        if (window.innerWidth < 768) { // 假设手机屏幕宽度小于768px
          setTableScroll({ x: 'max-content' });
        } else {
          setTableScroll(undefined);
        }
      };
  
      // 添加事件监听器
      window.addEventListener('resize', checkScreenSize);
  
      // 立即检查屏幕大小
      checkScreenSize();
  
      // 清除事件监听器
      return () => window.removeEventListener('resize', checkScreenSize);
    }, []);
    // useEffect(() => {
    //     const filteredData = data.filter(item => item.OrderTime.startsWith(selectedDate));
    //     setTableData(filteredData);
    // }, [data, selectedDate]); // 确保在 data 或 selectedDate 更新时重新筛选
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    
    const [lastTouchTime, setLastTouchTime] = useState(0);

    const onRowTouch = (record, e) => {
      const currentTime = new Date().getTime();
      const touchInterval = currentTime - lastTouchTime;
      if (touchInterval < 300 && touchInterval > 0) { // 300毫秒作为双击的阈值
        onRowDoubleClick(record);
      }
      setLastTouchTime(currentTime);
    };

    const parseOrderDetails = (orderDetails) => {
        try {
            const detailsArray = JSON.parse(orderDetails);
            return detailsArray.map((detailArray, index) => {
                // 主商品
                const mainItem = detailArray[1];
                const formattedItems = [];
    
                formattedItems.push(
                    <div key={`main-item-${index}`}>
                        <strong>{`Item ${index + 1}: ${mainItem.mainItemDescription} x ${mainItem.quantity}`}</strong>
                    </div>
                );
    
                // 子菜单项
                detailArray.slice(2).forEach((subItem, subIndex) => {
                    formattedItems.push(
                        <div key={`sub-item-${index}-${subIndex}`}>
                            <span>{`  - ${subItem.itemDescription} x ${subItem.quantity}`}</span>
                        </div>
                    );
                });
    
                return <div key={`item-container-${index}`}>{formattedItems}</div>;
            });
        } catch (error) {
            console.error('Error parsing order details:', error);
            return <span>Error</span>;
        }
    };
    
    
    const parseMainItemDetails = (orderDetails) => {
        try {
            const detailsArray = JSON.parse(orderDetails);
            const mainItemsElements = detailsArray.map((detailArray, index) => {
                if (index < 2) { // 仅处理前两项
                    return (
                        <div>
                            {/* <strong>Item {detailArray[0]}:</strong>  */}
                            {detailArray[1].mainItemDescription} x {detailArray[1].quantity}
                        </div>
                    );
                } else if (index === 2) { // 第三项仅显示省略号
                    return <div key={`main-item-ellipsis`}>...</div>;
                }
                return null; // 超过三项的不显示
            });
    
            // 过滤掉 null 值
            return mainItemsElements.filter(element => element !== null);
        } catch (error) {
            console.error('Error parsing order details:', error);
            return <span>Error</span>;
        }
    };
    
    
    const onRowDoubleClick = (record) => {
        const currentKey = record.OrderId;
        const isCurrentlyExpanded = expandedRowKeys.includes(currentKey);
        setExpandedRowKeys(
            isCurrentlyExpanded ? expandedRowKeys.filter(key => key !== currentKey) : [...expandedRowKeys, currentKey]
        );
    };

    const expandedRowRender = (record) => {
        const orderDetailsElements = parseOrderDetails(record.OrderDetails);
        
        return (
            <div>
                <h4>Order Details:</h4>
                <div>{orderDetailsElements}</div>
            </div>
        );
    };

   
    const listAll = () => {
        // setSelectedDate(null);
        setTableData(data);
    };

    // const handleDateChange = (date, dateString) => {
        
       
    //   setSelectedDate(dateString);
    // };
    // const handleSearch = () => {
    //     // 这里实现搜索逻辑，过滤出选定日期的订单
       
    //     if (selectedDate) {
    //         const filteredData = data.filter(item => item.OrderTime.startsWith(selectedDate));
    //         setTableData(filteredData);  // 更新表格数据
    //       } else {
    //         setTableData(data);  // 如果没有选择日期，则显示所有数据
    //       }
        
    // };
    const processedData = tableData.map(item => ({
        ...item, // This spreads all original properties including refunds
        orderId: item.OrderId,
        tableNo: item.TableNo, 
        serviceMode: item.ServiceMode,
        customerName: item.CustomerName,
        customerAddress: item.CustomerAddress,
        customerPhone: item.CustomerPhone,
        orderTime: item.OrderTime,  
        enrichOrderId: item.OrderEnrichNo,
        amount: item.TotalAmount,
        redeemAmount: Math.max(0, Number(item.RedeemAmountCents || 0)) / 100,
        redeemPoints: Math.max(0, Number(item.RedeemPoints || 0)),
        
        // 根据 EnrichOrderNo 决定 Tag
        tag: item.OrderEnrichNo ? 'success' : 'failed',
        orderDetails: parseOrderDetails(item.OrderDetails),
        // Explicitly ensure refunds are included
        refunds: item.refunds || []
      }));
    
  const columns = [
    {
      title: 'Transaction Id',
      dataIndex: 'orderId',
      key: 'orderId',
    },
    {
      title: 'Table No',  // Add this new column
      dataIndex: 'tableNo',
      key: 'tableNo',
      render: (tableNo, record) => {
        const serviceModeLabel = getServiceModeLabel(record.serviceMode);
        if (serviceModeLabel === 'Takeaway') {
          return <Tag color="blue">Takeaway</Tag>;
        }
        if (serviceModeLabel === 'Delivery') {
          return <Tag color="purple">Delivery</Tag>;
        }
        return tableNo || '-';
      },
    },
    {
      title: 'Customer',
      dataIndex: 'customerName',
      key: 'customerName',
      render: (customerName, record) => {
        const isExpanded = expandedRowKeys.includes(record.OrderId);
        const displayName = customerName || '-';
        const hasCustomerName = Boolean(customerName);

        return (
          <div>
            <div>{displayName}</div>
            {hasCustomerName && isExpanded && (
              <div style={{ marginTop: 4, color: '#666', fontSize: 12, lineHeight: 1.5 }}>
                <div>Address: {record.customerAddress || '-'}</div>
                <div>Phone: {record.customerPhone || '-'}</div>
              </div>
            )}
          </div>
        );
      },
    },
    {
        title: 'Transaction Time',
        dataIndex: 'orderTime',
        key: 'orderTime',
        sorter: (a, b) => new Date(a.orderTime) - new Date(b.orderTime),
    },
    {
      title: 'Order Id',
      dataIndex: 'enrichOrderId',
      key: 'enrichOrderId',
    },
    {
        title: 'Order Details',
        dataIndex: 'orderDetails',
        key: 'orderDetails',
        render: (_, record) => {
            const isExpanded = expandedRowKeys.includes(record.OrderId);
            const orderDetailsContent = isExpanded ? parseOrderDetails(record.OrderDetails) : parseMainItemDetails(record.OrderDetails);
            return (
                <div style={{ margin: 0, maxWidth: '400px' }}>
                    {orderDetailsContent}
                </div>
            );
        },
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        sorter: (a, b) => parseFloat(a.amount) - parseFloat(b.amount),
        render: (amount) => `$${formatAmount(amount)}`
      },
      {
        title: 'Redeem Amount / Points',
        key: 'redemption',
        sorter: (a, b) => a.redeemAmount - b.redeemAmount,
        render: (_, record) => Number(record.Paid || 0) > 0 && record.redeemPoints > 0
          ? `$${formatAmount(record.redeemAmount)} / ${record.redeemPoints}`
          : '—',
      },
      { 
        title:'Paid',
        dataIndex: 'Paid',
        key: 'Paid',
        sorter: (a, b) => parseFloat(a.Paid) - parseFloat(b.Paid),
        render: (paid) => `$${formatAmount(paid)}`
      },
    {
      title: 'Status',
      dataIndex: 'tag',
      key: 'tag',
      render: (tag) => {
        let color;
        switch (tag) {
          case 'success':
            color = 'green';
            break;
          case 'failed':
            color = 'volcano';
            break;
          default:
            color = 'geekblue';
        }
        return <Tag color={color}>{tag.toUpperCase()}</Tag>;
      },
    },
    // {
    //   title: 'Revoke',
    //   key: 'revoke',
    //   render: (_, record) => (
       
         
    //       <Button onClick={() => handleRevoke(record.orderId)}
    //       disabled={record.Paid} // 根据加载状态禁用按钮
    //         >
    //         Revoke
    //       </Button>
       
    //   ),
    // },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => {
        const refundStatus = getRefundStatus(record);
        
        return (
          <Space size="middle" direction="vertical">
            <Space size="small">
              {!record.OrderEnrichNo && (
                <>
                  <Button
                    onClick={() => handleResend(record.orderId)}
                    disabled={loadingStates[record.orderId]}
                    size="small"
                  >
                    {loadingStates[record.orderId] ? <Spin size="small" /> : 'Resend'}
                  </Button>
                  <Button
                    onClick={() => handleIgnore(record.orderId)}
                    disabled={loadingStates[`ignore_${record.orderId}`]}
                    danger
                    size="small"
                  >
                    {loadingStates[`ignore_${record.orderId}`] ? <Spin size="small" /> : 'Ignore'}
                  </Button>
                </>
              )}
              
              {/* 退款按钮 - 只在未完全退款且有支付记录时显示 */}
              {parseFloat(record.Paid) > 0.01 && record.StripePaymentId && !['FULLY_REFUNDED', 'REFUND_PENDING'].includes(refundStatus) && (
                <Button
                  onClick={() => handleRefundClick(record)}
                  disabled={refundLoading}
                  size="small"
                  style={{ backgroundColor: '#ff7875', borderColor: '#ff7875', color: 'white' }}
                >
                  {refundLoading && currentRefundOrder?.OrderId === record.OrderId ? 
                    <Spin size="small" /> : 'Refund'}
                </Button>
              )}
            </Space>
            
            {/* 退款状态标签 */}
            {refundStatus && (
              <Tag
                color={refundStatus === 'FULLY_REFUNDED' ? 'red' : refundStatus === 'REFUND_PENDING' ? 'gold' : 'orange'}
                style={{ cursor: 'pointer', margin: 0 }}
                onClick={() => handleRefundHistoryClick(record)}
              >
                {refundStatus === 'FULLY_REFUNDED'
                  ? 'Refunded'
                  : refundStatus === 'REFUND_PENDING'
                    ? 'Refund Pending'
                    : 'Partially Refunded'}
              </Tag>
            )}
          </Space>
        );
      },
    },
   
  ];

  return (
    <div>
      <h2>{title}</h2>
      <div style={{ marginBottom: 16 }}>
        
      <Select defaultValue="failed" className="order-filter-select" style={{ width: 120 }} onChange={handleFilterChange}>
          <Option value="failed">Failed</Option>
          <Option value="success">Success</Option>
          <Option value="all">All</Option>
        </Select>
        {/* <DatePicker style={{ marginLeft: 30 }}
            onChange={handleDateChange} format="YYYY-MM-DD" // 添加这一行
         /> */}
        {/* <Button onClick={handleSearch} style={{ marginLeft: 8 }}>Search</Button> */}
      </div>
      <Table
      columns={columns}
      dataSource={processedData}
      expandable={{
        expandedRowRender,
        expandedRowKeys,
        onExpand: (expanded, record) => {
          const currentKey = record.OrderId;
          setExpandedRowKeys(expanded ? [...expandedRowKeys, currentKey] : expandedRowKeys.filter(key => key !== currentKey));
         
        },
        expandIcon,
      }}
      onRow={(record) => ({
          onDoubleClick: () => onRowDoubleClick(record),
          onTouchEnd: (e) => onRowTouch(record, e), // 添加这一行
      })}
      pagination={{
        position: ['bottomCenter'],
        pageSize: 50,
      }}
      responsive
      scroll={tableScroll}
    />
    
    {/* 退款金额输入弹窗 */}
    <Modal
      title="Refund Amount"
      open={refundModalVisible}
      onOk={handleRefundAmountConfirm}
      onCancel={() => {
        setRefundModalVisible(false);
        setRefundAmount('');
        setCurrentRefundOrder(null);
      }}
      okText="Confirm"
      cancelText="Cancel"
    >
      <div style={{ marginBottom: 16 }}>
        <p>Order ID: {currentRefundOrder?.OrderEnrichNo}</p>
        <p>Payment Gateway: {currentRefundOrder?.PaymentGateway || storePaymentGateway || 'Unknown'}</p>
        <p>Refundable Amount: ${currentRefundOrder?.Paid}</p>
      </div>
      <div>
        <label>Refund Amount: </label>
        <Input
          type="number"
          value={refundAmount}
          onChange={(e) => setRefundAmount(e.target.value)}
          placeholder="Enter refund amount"
          prefix="$"
          min="0"
          max={currentRefundOrder?.Paid}
          step="0.01"
        />
      </div>
    </Modal>

    {/* 确认退款弹窗 */}
    <Modal
      title="Confirm Refund"
      open={confirmRefundModalVisible}
      onOk={handleFinalRefundConfirm}
      onCancel={() => {
        setConfirmRefundModalVisible(false);
        setConfirmText('');
      }}
      okText="Confirm Refund"
      cancelText="Cancel"
      confirmLoading={refundLoading}
    >
      <div style={{ marginBottom: 16 }}>
        <p>Order ID: {currentRefundOrder?.OrderEnrichNo}</p>
        <p>Payment Gateway: {currentRefundOrder?.PaymentGateway || storePaymentGateway || 'Unknown'}</p>
        <p>Refund Amount: ${refundAmount}</p>
        <p style={{ color: 'red', fontWeight: 'bold' }}>
          Note: This action cannot be undone. Please confirm the refund information is correct.
        </p>
      </div>
      <div>
        <label>Please enter "refund" to confirm: </label>
        <Input
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder="Enter refund"
        />
      </div>
    </Modal>
    {/* 退款历史显示弹窗 */}
    <Modal
      title="Refund History"
      open={refundHistoryModalVisible}
      onCancel={() => {
        setRefundHistoryModalVisible(false);
        setCurrentRefundOrder(null);
      }}
      footer={[
        <Button key="close" onClick={() => setRefundHistoryModalVisible(false)}>
          Close
        </Button>
      ]}
      width={600}
    >
      {currentRefundOrder && (
        <div>
          <div style={{ marginBottom: 20, padding: '12px', background: '#f5f5f5', borderRadius: '6px' }}>
            <h4 style={{ margin: '0 0 8px 0' }}>Order Information</h4>
            <p style={{ margin: '4px 0' }}><strong>Order ID:</strong> {currentRefundOrder.OrderEnrichNo}</p>
            <p style={{ margin: '4px 0' }}><strong>Payment Gateway:</strong> {currentRefundOrder.PaymentGateway || storePaymentGateway || 'Unknown'}</p>
            <p style={{ margin: '4px 0' }}><strong>Remaining Refundable:</strong> ${parseFloat(currentRefundOrder.Paid).toFixed(2)}</p>
            <p style={{ margin: '4px 0' }}>
              <strong>Total Refunded:</strong> 
              <span style={{ color: '#ff4d4f', fontWeight: 'bold', marginLeft: '4px' }}>
                ${(currentRefundOrder.refunds || []).reduce((sum, refund) => {
                  return refund.Status === 'SUCCESS' ? sum + parseFloat(refund.RefundAmount) : sum;
                }, 0).toFixed(2)}
              </span>
            </p>
          </div>
          
          {currentRefundOrder.refunds && currentRefundOrder.refunds.length > 0 ? (
            <div>
              <h4>Refund Records:</h4>
              <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {currentRefundOrder.refunds.map((refund, index) => (
                  <div key={index} style={{ 
                    marginBottom: '12px', 
                    padding: '12px', 
                    background: 'white', 
                    borderRadius: '6px',
                    border: `2px solid ${refund.Status === 'SUCCESS' ? '#52c41a' : refund.Status === 'FAILED' ? '#ff4d4f' : '#faad14'}`,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                      <span style={{ fontSize: '16px', fontWeight: 'bold' }}>Refund #{index + 1}</span>
                      <span style={{ 
                        color: refund.Status === 'SUCCESS' ? '#52c41a' : refund.Status === 'FAILED' ? '#ff4d4f' : '#faad14',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        background: refund.Status === 'SUCCESS' ? '#f6ffed' : refund.Status === 'FAILED' ? '#fff2f0' : '#fffbe6'
                      }}>
                        {refund.Status}
                      </span>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '14px' }}>
                      <div>
                        <strong>Amount:</strong> 
                        <span style={{ color: '#52c41a', fontWeight: 'bold', marginLeft: '4px' }}>
                          ${parseFloat(refund.RefundAmount).toFixed(2)}
                        </span>
                      </div>
                      <div>
                        <strong>Date:</strong> 
                        <span style={{ marginLeft: '4px' }}>
                          {new Date(refund.CreatedAt).toLocaleString()}
                        </span>
                      </div>
                      {refund.RefundId && (
                        <div style={{ gridColumn: '1 / -1' }}>
                          <strong>Refund ID:</strong> 
                          <span style={{ marginLeft: '4px', fontFamily: 'monospace', fontSize: '12px' }}>
                            {refund.RefundId}
                          </span>
                        </div>
                      )}
                      {refund.PaymentGateway && (
                        <div style={{ gridColumn: '1 / -1' }}>
                          <strong>Payment Gateway:</strong>
                          <span style={{ marginLeft: '4px' }}>{refund.PaymentGateway}</span>
                        </div>
                      )}
                      {refund.ErrorMessage && (
                        <div style={{ gridColumn: '1 / -1', color: '#ff4d4f' }}>
                          <strong>Error:</strong> 
                          <span style={{ marginLeft: '4px' }}>{refund.ErrorMessage}</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
              No refund records found for this order.
            </div>
          )}
        </div>
      )}
    </Modal>
    </div>
  );
};

export default CustomTable;
